import React from "react";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
// import InvoiceListingTable from "./InvoiceListingTable";
import CreateInvoiceNewList from "./CreateInvoiceNewList";
import swal from "sweetalert";
import { makePostRequest } from "../../../utils/utils";

function InvoiceListing() {
  const navigate = useNavigate();

  // async function InvoiceAutoGeneration() {
  //   makeGetRequest("invoice/autoinvoice", "")
  //     .then((response) => {
  //       if (response.status == "201") {
  //         swal(
  //           "Auto Invoice Generation completed!",
  //           response.message,
  //           "success"
  //         );
  //       } else {
  //         swal("There was an error!", response.message, "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  async function handleCreateButton() {
    let bodyFormData={
      status:"true",
      invoiceType:"Monthly Maintenance"
    }
    makePostRequest("bankdetails/getallbystatus",bodyFormData)
    .then((response) => {
      if (response.status === 201) {

        const data = response.data.data;
        
        console.log(data.length);
        if(response.data.data.length)
        {
          navigate("/CreateInvoiceNew");
        }
        else
        {
          swal("Please Configure Invoice Settings","Bank Details for Monthly Invoice not configured","warning",{
            timer: 5000,
            buttons: false,
          })

          navigate("/InvoiceSettings");
        }
      } else {
        swal("There was an error!", response.message, "warning");
      }
    })
    .catch((err) => {
      swal("There was an error!", "more error details", "warning");
    });
  }
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Create Invoice</h1>
            {/* <Button
              className="primaryBtn sendInvoiceBt"
              onClick={() => InvoiceAutoGeneration()}
            >
               Invoice Auto Generation
            </Button> */}
            {/* <Button className="primaryBtn sendInvoiceBt sendInvoiceBt2">
              Send Invoice
            </Button> */}
            <Button
              className="primaryBtn"
              onClick={() => handleCreateButton()}
            >
              Create New Invoice
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <InvoiceListingTable /> */}
              <CreateInvoiceNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default InvoiceListing;
